import ShopCategory from './components/ShopCategory';
import ShopInfo from './components/ShopInfo';
import ShopNavBar from './components/ShopNavBar';
import ShopBanner from './components/ShopBanner';
import { useEffect, useRef } from 'react';

function setIframeHeight(iframe) {
  if (iframe) {
    iframe.style.display = 'block';
    var frameRefWin = iframe.contentWindow;
    if (frameRefWin.document.body) {
      iframe.height = String(
        frameRefWin.document.documentElement.scrollHeight || frameRefWin.document.body.scrollHeight,
      );
    }
  }
}

export default function ShopProfile({ shopData }) {
  const frameRef = useRef<HTMLIFrameElement>();
  useEffect(() => {
    window.addEventListener('message', function (res) {
      if (res.data === 'changeHeight') {
        setIframeHeight(frameRef.current);
      }
    });
  }, []);

  return (
    <>
      <div className="shop-container">
        <ShopBanner shop={shopData} />
        <ShopNavBar pageType={'profile'} />
        <div className="shop-wrap">
          <div className="shop-left">
            <ShopInfo shop={shopData} />
            <ShopCategory
              twoShopCustomCategoryTreeDTOList={shopData.shopCustomCategoryTreeDTOList}
            />
          </div>
          <div className="shop-right">
            <iframe
              ref={frameRef}
              width={'100%'}
              style={{ border: 'none', display: 'none' }}
              src={`/pages/shop/profile/${shopData.supplierSysNo}?inIframe=1`}
            />
          </div>
        </div>
      </div>

      <style jsx>
        {`
          .shop-container {
            margin-bottom: 20px;
          }
          .shop-right{
            float: right;
            width: 956px;
            height: auto;
            margin-top: 20px;
          }
          .shop-left{
            float: left;
            width: 224px;
            height: auto;
            margin-top: 20px;
          }
          .shop-wrap{
            position: relative;
            width: 1200px;
            margin: 0 auto;
          }
          .shop-wrap:after{
            clear: both;
            display: block;
            content:"";
          }
          `}
      </style>
    </>
  );
}
